<template>
  <v-select
    v-model="language"
    :items="languages"
    item-title="label"
    item-value="value"
    density="compact"
    hide-details
    variant="outlined"
    class="lang-select"
    style="
      position: fixed;
      bottom: 20px;
      right: 20px;
      max-width: 160px;
      background-color: white !important;
      font-size: 12px;
      border-radius: 8px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      z-index: 2000;
      color: black !important;
    "
  >
    <!-- Bandera + texto en el valor seleccionado  slot de selection-->
    <template #selection="{ item }">
      <v-icon style="margin-right: 20%;">{{item.raw.icon}}</v-icon>
      
      <span>{{ item.raw.label }}</span>
    </template>

    <!-- Bandera + texto en cada opcion del menu -->
    <template #item="{ props, item }">
      <v-list-item v-bind="props" :title="null">
        <template #prepend>
           <v-icon>{{item.raw.icon}}</v-icon>
      
        </template>
        <v-list-item-title>{{ item.raw.label }}</v-list-item-title>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
import { useSettingsStore } from "@/stores/settings";
export default {
  name: "LanguajeSelector",
  data() {
    return {
      languages: [
        {
          label: "ES",
          value: "es",
          icon: "mdi-web",
        },
        {
          label: "EN",
          value: "en",
          icon: "mdi-web",
        },
      ],
    };
  },
  computed: {
    language: {
      get() {
        const settings = useSettingsStore();
        return settings.language;
      },
      set(value) {
        const settings = useSettingsStore();
        settings.setLenguage(value);
      },
    },
  },
};
</script>

<style scoped>
.bandera-img {
  width: 20px;
  height: 15px;
  object-fit: cover;
  margin-right: 8px;
  border-radius: 2px;
  vertical-align: middle;
}
</style>
